import React, { useEffect, useState } from 'react';
import useAuthStore from '../store/useAuthStore';
import axiosInstance from '../api/axios';
import { motion } from 'framer-motion';
import { Users, FileText, DollarSign, AlertCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
    const { user, isGuest } = useAuthStore();
    const navigate = useNavigate();
    
    // حالة لتخزين الإحصائيات
    const [stats, setStats] = useState({ clients: 0, invoices: 0, revenue: 0 });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // 1. لو المستخدم زائر (Guest): اعرض بيانات وهمية فوراً وماتكلمش الباك إند
        if (isGuest) {
            setStats({ clients: 12, invoices: 34, revenue: 4500 });
            setIsLoading(false);
            return; // وقف التنفيذ هنا عشان ميروحش للـ API
        }

        // 2. لو مستخدم حقيقي: جيب بياناته من الباك إند
        const fetchStats = async () => {
            try {
                // (تأكد إن الراوت ده موجود عندك في لارافل، أو غيره حسب اللي بتستخدمه)
                const response = await axiosInstance.get('/dashboard-stats'); 
                setStats(response.data);
            } catch (error) {
                console.error("Error fetching stats:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchStats();
    }, [isGuest]);

    if (isLoading) return <div style={{ padding: '40px', textAlign: 'center' }}>Loading dashboard...</div>;

    return (
        <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto', width: '100%' }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
                <div>
                    <h1 style={{ margin: 0, color: '#0f172a' }}>
                        Welcome, {isGuest ? 'Guest' : user?.name} 👋
                    </h1>
                    <p style={{ color: '#64748b', margin: '8px 0 0' }}>Here's what's happening with your business today.</p>
                </div>
                
                {/* 🚨 رسالة التسويق للزوار (Call to Action) */}
                {isGuest && (
                    <motion.div initial={{ x: 20, opacity: 0 }} animate={{ x: 0, opacity: 1 }} style={{ backgroundColor: '#fffbeb', border: '1px solid #fde68a', padding: '12px 20px', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <AlertCircle color="#d97706" size={20} />
                        <span style={{ color: '#92400e', fontSize: '14px', fontWeight: '500' }}>You are in preview mode.</span>
                        <button onClick={() => navigate('/register')} style={{ backgroundColor: '#d97706', color: 'white', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer', fontWeight: '600' }}>
                            Sign Up to Save
                        </button>
                    </motion.div>
                )}
            </div>

            {/* كروت الإحصائيات الوهمية أو الحقيقية */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
                <div className="glass-card" style={{ padding: '24px', backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <div style={{ padding: '10px', backgroundColor: '#eff6ff', borderRadius: '8px' }}><Users color="#3b82f6" /></div>
                        <h3 style={{ margin: 0, fontSize: '16px', color: '#64748b' }}>Total Clients</h3>
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a' }}>{stats.clients}</div>
                </div>

                <div className="glass-card" style={{ padding: '24px', backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <div style={{ padding: '10px', backgroundColor: '#ecfdf5', borderRadius: '8px' }}><FileText color="#10b981" /></div>
                        <h3 style={{ margin: 0, fontSize: '16px', color: '#64748b' }}>Invoices Generated</h3>
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a' }}>{stats.invoices}</div>
                </div>

                <div className="glass-card" style={{ padding: '24px', backgroundColor: 'white', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <div style={{ padding: '10px', backgroundColor: '#fef2f2', borderRadius: '8px' }}><DollarSign color="#ef4444" /></div>
                        <h3 style={{ margin: 0, fontSize: '16px', color: '#64748b' }}>Total Revenue</h3>
                    </div>
                    <div style={{ fontSize: '32px', fontWeight: '800', color: '#0f172a' }}>${stats.revenue}</div>
                </div>
            </div>

        </div>
    );
};

export default Dashboard;